import Vue from 'vue'
import Vuex from 'vuex'
import feathersClient from './feathers-client'
import router from './router'
import i18nFunc from './i18n'
import VueRouter from 'vue-router'

Vue.use(Vuex)

const i18n = i18nFunc()
const defaultState = {
  targetsList: [],
  targetsSchema: {},
  targetsForApproval: 0,
  indicatorsList: [],
  indicatorsSchema: {},
  indicatorsForApproval: 0,
  isDrawerOpen: false,
  user: {},
  loading: false,
  serviceError: '',
  users: [],
  standardValues: {},
  rollingValues: {},
  averageValues: {},
  latestAverageValues: {},
  companies: {},
  userPayments: [],
}

export default new Vuex.Store({
  state: Object.assign({}, defaultState),
  mutations: {
    showLoading(state) {
      state.loading = true
    },
    hideLoading(state) {
      state.loading = false
    },
    authSuccess(state, res) {
      Object.assign(state, defaultState)
      state.user = res.user
      // state.user.isAdmin = Array.isArray(res.user.permissions) && res.user.permissions.includes('admin')
    },
    // eslint-disable-next-line no-unused-vars
    showSnackbarMessage(state, message) {},
    showSnackbarWarning(state, message) {},
    showSnackbarError(state, message) {},
    // eslint-disable-next-line no-unused-vars
    showServiceError(state, err) {
      if (err.code === 401) router.replace({ name: 'login' })
      state.serviceError = err
    },
    // eslint-disable-next-line no-unused-vars
    authError(state) {},
    logout(state) {
      Object.assign(state, defaultState)
    },
    isDrawerOpen(state, value) {
      state.isDrawerOpen = value
    },
    onTargets(state, value) {
      if (value && value.schema) {
        state.targetsSchema = value.schema
      }
      // state.targets = value.data
    },
    onTargetsList(state, value) {
      state.targetsList = value.data
    },
    onItemsForApproval(state, value) {
      state.targetsForApproval = value.targets
      state.indicatorsForApproval = value.indicators
    },
    onIndicatorsList(state, value) {
      state.indicatorsList = value.data
    },
    onUsersList(state, res) {
      this.state.users = res.data
    },
    onUserRegistered(state, res) {
      if (res.paymentUrl) {
        window.location = res.paymentUrl
      } else {
        router.replace({ name: 'login' })
      }
    },
    onUserUpdated(state, res) {},
    onOwnUserUpdated(state, res) {
      this.state.user = res
    },
    onCompanyRegistered(state, res) {
      this.state.company = res
    },
    // eslint-disable-next-line no-unused-vars
    registrationError(state, value) {},
    onIndicatorsCreated(state, value) {
      //D state.indicators = value.data
    },
    onIndicators(state, value) {
      // D state.indicators = value.data
      if (value && value.schema) {
        state.indicatorsSchema = value.schema
      }
    },
    onStandardValues(state, value) {
      state.standardValues = value
    },
    onRollingValues(state, value) {
      state.rollingValues = value
    },
    onAverageValues(state, value) {
      state.averageValues = value
    },
    onLatestAverageValues(state, value) {
      state.latestAverageValues = value.data[0]
    },
    onUserPayments(state, value) {
      state.userPayments = value.data
    },
    onTargetsUpdated(state, value) {
      if (value.schema) {
        state.schema = value.schema
      }
      //D state.targets = [value]
    },
    onIndicatorsUpdated(state, value) {
      //D state.indicators = [value]
      if (value.schema) {
        state.indicatorsSchema = value.schema
      }
    },
    onUserCompany(state, companies) {
      const company = companies.data[0]
      if (company) Vue.set(state.companies, company.tankNumber, company)
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('showLoading')
        feathersClient
          .authenticate({
            strategy: 'local',
            email: user.email,
            password: user.password,
          })
          .then((res) => {
            // Logged in
            //   res.isAdmin = Array.isArray(res.permissions) && res.permissions.includes('admin')
            commit('authSuccess', res)
            commit('hideLoading')
            resolve(res)
          })
          .catch((err) => {
            // Show login page (potentially with `e.message`)
            commit('showServiceError', err)
            commit('hideLoading')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      feathersClient
        .logout()
        .then(() => {
          // JWT authentication successful
          commit('logout')
        })
        .catch((err) => {
          commit('showServiceError', err)
          // Show login page
        })
    },
    registerUser({ commit }, data) {
      commit('showLoading')

      feathersClient
        .service('users')
        .create(data)
        .then((res) => {
          commit('onUserRegistered', res)
          commit('showSnackbarMessage', 'message.user_profile_created')
          commit('hideLoading')
        })
        .catch((err) => {
          commit('registrationError', err)
          commit('hideLoading')
        })
    },
    reloadUser({ commit }) {
      commit('showLoading')
      feathersClient
        .service('users')
        .get(this.state.user._id)
        .then((res) => {
          commit('onOwnUserUpdated', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('hideLoading')
        })
    },
    registerCompany({ commit }, data) {
      commit('showLoading')

      feathersClient
        .service('companies')
        .create(data)
        .then((res) => {
          commit('onCompanyRegistered', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('registrationError', err)
          commit('hideLoading')
        })
    },
    updateUserProfile({ commit }, data) {
      commit('showLoading')

      feathersClient
        .service('users')
        .patch(data._id, data)
        .then((res) => {
          commit('showSnackbarMessage', 'message.user_profile_updated')
          if (this.state.user._id === data._id) {
            commit('onOwnUserUpdated', res)
          } else {
            commit('onUserUpdated', res)
          }
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getItemsForApproval({ commit }) {
      const query = {
        query: {
          $select: ['_id'],
          isDraft: false,
          approvedOn: null,
          $limit: 0,
        },
      }
      Promise.all([
        feathersClient.service('targets').find(query),
        feathersClient.service('indicators').find(query),
      ])
        .then((res) => {
          commit('onItemsForApproval', {
            targets: res[0].total,
            indicators: res[1].total,
          })
        })
        .catch((err) => {
          commit('showServiceError', err)
        })
    },
    getTargets({ commit }, query = {}) {
      query.$limit = 1000
      commit('showLoading')
      feathersClient
        .service('targets')
        .find(query)
        .then((res) => {
          res.schema.title = ''
          res.schema.description = ''

          commit('onTargets', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getTargetsList({ commit }) {
      commit('showLoading')
      feathersClient
        .service('targets')
        .find({
          query: {
            $select: ['_id', 'isDraft', 'date', 'approvedOn', 'userId'],
          },
        })
        .then((res) => {
          commit('onTargetsList', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getIndicatorsList({ commit }) {
      commit('showLoading')
      let q = {
        $select: ['_id', 'isDraft', 'date', 'approvedOn', 'userId'],
      }

      feathersClient
        .service('indicators')
        .find(q)
        .then((res) => {
          commit('onIndicatorsList', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getIndicators({ commit }, query = {}) {
      commit('showLoading')
      feathersClient
        .service('indicators')
        .find(query)
        .then((res) => {
          res.schema.title = ''
          res.schema.description = ''
          commit('onIndicators', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getStandardValues({ commit }, query = { query: { $sort: { date: -1 } } }) {
      commit('showLoading')
      feathersClient
        .service('standard-values')
        .find(query)
        .then((res) => {
          commit('onStandardValues', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getRollingValues({ commit }, query = { query: { $sort: { date: -1 } } }) {
      commit('showLoading')
      feathersClient
        .service('rolling-values')
        .find(query)
        .then((res) => {
          commit('onRollingValues', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getAverageValues({ commit }, query = { query: { $sort: { date: -1 } } }) {
      commit('showLoading')
      feathersClient
        .service('average-values')
        .find(query)
        .then((res) => {
          commit('onAverageValues', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getLatestAverageValues(
      { commit },
      query = { query: { $sort: { date: -1 }, $limit: 1 } }
    ) {
      commit('showLoading')
      feathersClient
        .service('average-values')
        .find(query)
        .then((res) => {
          commit('onLatestAverageValues', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    saveStandardValues({ commit }, data) {
      commit('showLoading')

      feathersClient
        .service('standard-values')
        .create(data)
        .then(() => {
          this.dispatch('getStandardValues')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    saveRollingValues({ commit }, data) {
      commit('showLoading')

      feathersClient
        .service('rolling-values')
        .create(data)
        .then(() => {
          this.dispatch('getRollingValues')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    saveAverageValues({ commit }, data) {
      commit('showLoading')

      feathersClient
        .service('average-values')
        .create(data)
        .then(() => {
          this.dispatch('getAverageValues')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    createIndicators({ commit }, data) {
      commit('showLoading')

      feathersClient
        .service('indicators')
        .create(data)
        .then((res) => {
          commit('onIndicatorsCreated', res)
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getUsers({ commit }, query = { query: { $limit: 100 } }) {
      commit('showLoading')
      feathersClient
        .service('users')
        .find(query)
        .then((res) => {
          commit('onUsersList', res)
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
    getCompany({ commit }, query) {
      feathersClient
        .service('companies')
        .find(query)
        .then((res) => {
          commit('onUserCompany', res)
        })
        .catch((err) => {
          commit('showServiceError', err)
        })
    },
    getUserPayments({ commit }, query) {
      if (query.query && query.query.status === 'all') {
        query.query.status = [
          'paid',
          'open',
          'pending',
          'failed',
          'expired',
          'canceled',
        ]
      } else {
        query.query.status = ['open', 'pending']
      }

      feathersClient
        .service('customer-payments')
        .find(query)
        .then((res) => {
          commit('onUserPayments', res)
        })
        .catch((err) => {
          commit('showServiceError', err)
        })
    },

    saveIndicatorsOrTargets({ commit }, { data, serviceName }) {
      const schema =
        serviceName == 'targets'
          ? this.state.targetsSchema
          : this.state.indicatorsSchema
      if (!data.date) delete data.date
      if (!data.draft) delete data.draft
      if (!data._id || Object.keys(data._id).length == 0) delete data._id
      if (!data.userId) delete data.userId

      Object.keys(data)
        .filter((key) => {
          return data[key] != null && typeof data[key] === 'object'
        })
        .forEach((cat) => {
          Object.keys(data[cat]).forEach((j) => {
            if (
              !!schema.properties[cat].properties[j].enum &&
              data[cat][j] == null
            ) {
              delete data[cat][j]
            }
          })
        })
      const serviceCall = data._id
        ? feathersClient.service(serviceName).patch(data._id, data)
        : feathersClient.service(serviceName).create(data)

      serviceCall
        .then((res) => {
          commit(
            serviceName === 'targets'
              ? 'onTargetsUpdated'
              : 'onIndicatorsUpdated',
            res
          )

          if (
            data.hasOwnProperty('isDraft') ||
            data.hasOwnProperty('approvedOn')
          ) {
            this.dispatch('getItemsForApproval')
          }
          commit('hideLoading')
        })
        .catch((err) => {
          commit('showServiceError', err)
          commit('hideLoading')
        })
    },
  },
})
